import { zodSchemes } from '@approvalmax/utils';
import { Sector } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { messages } from './messages';

const baseSchema = z.object({
    sector: zodSchemes.required.select.enum(Sector),
});

const noWebsiteSchema = baseSchema.extend({
    noBusinessWebsite: z.literal(true),
    businessWebsite: zodSchemes.optional.textField.url.nullable(),
    businessActivityDescription: zodSchemes.required.textField.string(),
    documentSources: zodSchemes.fileRecord.array().nonempty({ message: messages.documentsRequired }),
});

const websiteSchema = baseSchema.extend({
    noBusinessWebsite: z.literal(false),
    businessWebsite: zodSchemes.required.textField.url(),
    businessActivityDescription: zodSchemes.optional.textField.string.nullable(),
    documentSources: zodSchemes.fileRecord.array(),
});

export const businessInformationSchema = z.discriminatedUnion('noBusinessWebsite', [
    noWebsiteSchema.passthrough(),
    websiteSchema.passthrough(),
]);

export const schema = z
    .object({
        businessInformation: businessInformationSchema,
    })
    .passthrough();
